/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  Traktor constants
 */

// Current search view list names
export const CURRENT_SEARCH_VIEW = 'mapList'
export const NEARBY = 'nearby'
export const FAVORITES = 'favorite'
export const MESSAGED = 'messaged'
export const SAVED_SEARCHES = 'alert'

// Similar and nearby list names
export const DETAIL_SIMILAR_INACTIVE = 'detailSimilarInactive'
export const DETAIL_SIMILAR = 'detailSimilar'
export const DETAIL_SIMILAR_TOP = 'detailSimilarTop'
